import { selectCurrentSalonId } from 'selectors/currentSalon.selectors';
import selectUserRoleFromLogin from 'selectors/selectUserRoleFromLogin';
import { selectParsedToken, selectPinUserIsCustomerSupport, selectPinUserIsPrimary, selectUserNameFromPin, selectUserRoleFromPin, selectUserRoleFromSalon } from 'selectors/simple';
import { selectCognitoAttributes } from 'utils/cognito.util';
import fromAnyToString from 'utils/converters/fromAnyToString';

const selectEffectiveUserInfo = (state) => {
  if (selectPinUserIsPrimary(state) === false) {
    const { salonId, email } = selectParsedToken(state) || {};

    return {
      customerSupport: fromAnyToString(selectPinUserIsCustomerSupport(state)),
      name: fromAnyToString(selectUserNameFromPin(state)),
      role: fromAnyToString(selectUserRoleFromPin(state)),
      email: fromAnyToString(email),
      salonId,
    };
  }

  const { name, email } = selectCognitoAttributes(state) ?? {};
  const role = fromAnyToString(selectUserRoleFromSalon(state) || selectUserRoleFromLogin(state));

  return { name, email, role, salonId: selectCurrentSalonId(state) };
};

// noinspection JSUnusedGlobalSymbols
export default selectEffectiveUserInfo;
